import { Component, DestroyRef, EventEmitter, inject, Output } from '@angular/core';
import { CoreModule } from '../../../core/core.module';
import { LucideAngularModule, ReceiptText } from 'lucide-angular';
import { UserService } from '../../../services/user.service';
import { UserModel } from '../../../models';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LocalStorageService } from '../../../services/local-storage.service';
import { ButtonComponent } from '@mos-core/components/button/button.component';

@Component({
	selector: 'app-terms-and-conditions',
	standalone: true,
	imports: [CoreModule, LucideAngularModule, ButtonComponent],
	templateUrl: './terms-and-conditions.component.html',
})
export class TermsAndConditionsComponent {
	@Output() public termsAccepted = new EventEmitter<boolean>();

	public termsCheckboxChecked: boolean = false;
	public currentUser: UserModel;

	private destroyRef = inject(DestroyRef);

	constructor(
		private userService: UserService,
		private localStorageService: LocalStorageService,
	) {
		this.currentUser = this.localStorageService.getUserDetails();
	}

	public acceptTermsAndConditions(): void {
		if (!this.termsCheckboxChecked) {
			return;
		}

		this.userService
			.acceptTermsAndConditions(this.currentUser?.id)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(response => {
				// Update local storage with the user object from the response
				this.localStorageService.updateSessionUser(response.user);

				// Also update the local component property
				this.currentUser = response.user;

				// Emit the accept event
				this.termsAccepted.emit(true);
			});
	}

	protected readonly ReceiptText = ReceiptText;
}
